import { MessageSquare, Mail, Phone, Link2, Navigation, Settings, Database } from 'lucide-react';
import { t } from '@/i18n';

export const stateStyles = {
  'no-info': 'bg-red-100 text-red-700 border-red-200',
  'not-coming': 'bg-red-100 text-red-700 border-red-200',
  'no-power': 'bg-orange-100 text-orange-700 border-orange-200',
  'rescheduled': 'bg-amber-100 text-amber-700 border-amber-200',
  'confirmed': 'bg-blue-100 text-blue-700 border-blue-200',
  'en-route': 'bg-sky-100 text-sky-700 border-sky-200',
  'on-site': 'bg-violet-100 text-violet-700 border-violet-200',
  'loaded': 'bg-gray-100 text-gray-600 border-gray-200',
};

export const stateLabel = (state) => t(`arrivals.state.${state}`);

export const channelIcons = {
  sms: MessageSquare,
  whatsapp: MessageSquare,
  email: Mail,
  phone: Phone,
  voice: Phone,
  link: Link2,
  gps: Navigation,
  system: Settings,
  sap: Database,
};

export const channelLabel = (channel) => t(`arrivals.channel.${channel}`);
